import React, { useState, useLayoutEffect,useEffect } from "react";
import AdminNotifications from "../components/AdminNotifications";
import AdminPolicies from "../components/AdminPolicies";
import AdminSupplierSettings from "../components/AdminSupplierSettings";
import { AdminAccessSearch } from "../components/AdminAccessSearch";
import { AdminDashboards } from "../components/AdminDashboards";
import { AdminInactiveAccounts } from "../components/AdminInactiveAccounts";
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import "../styles/Admin.css";
import ServiceCalls from "../utils/serviceCalls.js";
import { Loading } from "../components/Loading";
import { AdminAuditLogs } from "../components/AdminAuditLogs";
import { AdminPeopleSoft } from "../components/AdminPeopleSoft";

export function Admin(props) {
	const [currentSupplier, setCurrentSupplier] = useState(props.currentCompanyId);
	const [hasAccess, setHasAccess] = useState(false);
	const [pending, setPending] = useState(true);
	const [tabKey, setTabKey] = useState('accessSearch');
	const [auditLogsActive, setAuditLogsActive] = useState(false);
	const [notificationsActive, setNotificationsActive] = useState(false); //Deafault to Access Search for Apr 2024 release
	const [accessSearchActive, setAccessSearchActive] = useState(true);//Deafault to Access Search for Apr 2024 release
	const [policyActive, setPolicyActive] = useState(false);
	const [dashboardActive, setDashboardActive] = useState(false);
	const [inactiveAccountsActive, setInactiveAccountsActive] = useState(false);
	const [supplierSettingsActive, setSupplierSettingsActive] = useState(false);
	const [peopleSoftFilesActive, setPeopleSoftFilesActive] = useState(false);
	useLayoutEffect(() => {
		console.log(`ADMIN NEW SUPPLIER: ${props.currentCompanyId}`);
		setCurrentSupplier(props.currentCompanyId);
		checkAdminAccess();
	}, [props.currentCompanyId]);

	const checkAdminAccess = () => {
		
		//setPending(true);
		ServiceCalls.checkAdminAccess().then(
			function (data) {
				if (data) {
					if (data === true) {
						if (!hasAccess) {
							setHasAccess(true);
							console.log("Already Has access");
						}
					} else {
						console.log("No access");
						setHasAccess(false);
						setPending(false);
					}
				} else {
					console.log("No access too");
					setHasAccess(false);
					setPending(false);
				}
			}
		);
	}
	const switchSearchTabs = (tab) => {
		setTabKey(tab);
		checkAdminAccess();
		setNotificationsActive(tab === "notifications");
		setAccessSearchActive(tab === "accessSearch" || (tab !== "auditLogs" && tab !== "notifications" && tab !== "policy" && tab !== "dashboard" && tab !== "inactive" && tab !== "supplierSettings" && tab !== "peopleSoftFiles"));
		setPolicyActive(tab === "policy");
		setAuditLogsActive(tab === "auditLogs");
		setDashboardActive(tab === "dashboard");
		setInactiveAccountsActive(tab === "inactive");
		setSupplierSettingsActive(tab === "supplierSettings");
		setPeopleSoftFilesActive(tab === "peopleSoftFiles");
	};


    return (
        <Container id="AdminSelections" fluid>
            <Row>
				<Col sm={4}><h3 style={{ marginTop: "10px" }} className="primaryText">Administration</h3></Col>
				{(dashboardActive === true)
				? <Col sm={8}>					
					<div className="dashboardMsg">
						Note: All dates and times are in UTC.
					</div>
				  </Col>
					: <Col sm={8}><div></div></Col>
				}
            </Row>
            {
                (hasAccess) ?
                   <Tab.Container className="adminOpts" activeKey={tabKey} onSelect={(k) => switchSearchTabs(k)}>
                            <Row>
                                <Col sm={3}>
                                    <Nav variant="pills" className="flex-column searchTypeSel borderCurve">
									<div><span id="tabTitle">Choose Admin Functionality</span></div>
									<Nav.Item>
										<Nav.Link className="searchTabs" eventKey="accessSearch">Access Search</Nav.Link>
									</Nav.Item>
									<Nav.Item>
										<Nav.Link className="searchTabs" eventKey="auditLogs">Audit Logs</Nav.Link>
									</Nav.Item>
									<Nav.Item>
										<Nav.Link className="searchTabs" eventKey="dashboard">Dashboards</Nav.Link>
									</Nav.Item>							
                                    <Nav.Item>
                                        <Nav.Link className="searchTabs" eventKey="notifications">Notifications</Nav.Link>
									</Nav.Item>
									<Nav.Item>
										<Nav.Link className="searchTabs" eventKey="peopleSoftFiles">PeopleSoft Files</Nav.Link>
									</Nav.Item>
									<Nav.Item>
										<Nav.Link className="searchTabs" eventKey="inactive">Restricted Users</Nav.Link>
									</Nav.Item>
									<Nav.Item>
										<Nav.Link className="searchTabs" eventKey="supplierSettings">Supplier Settings</Nav.Link>
									</Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link className="searchTabs" eventKey="policy">Terms of Service</Nav.Link>
                                    </Nav.Item>
                                    </Nav>
                                </Col>
							<Col sm={9}>
								<Tab.Content>
									{/*  **** ACCESS SEARCH *****/}
									<Tab.Pane eventKey="accessSearch">{accessSearchActive ? <AdminAccessSearch onChildUpdate={checkAdminAccess} /> : <></>}</Tab.Pane>
									{/*  **** ADMIN LOGS *****/}
									<Tab.Pane eventKey="auditLogs" style={{ marginTop: "10px" }}>
										{auditLogsActive ? <AdminAuditLogs onChildUpdate={checkAdminAccess} /> : <></>}
									</Tab.Pane>
									{/*  **** DASHBOARDS  *****/}
									<Tab.Pane eventKey="dashboard">
										{dashboardActive === true ? <AdminDashboards onChildUpdate={checkAdminAccess} /> : <></>}
									</Tab.Pane>
									{/*  **** NOTIFICATIONS *****/}
									<Tab.Pane eventKey="notifications">{notificationsActive ? <AdminNotifications onChildUpdate={checkAdminAccess} /> : <></>}</Tab.Pane>
									{/*  **** POLICY UPDATE *****/}
									<Tab.Pane eventKey="policy">{policyActive ? <AdminPolicies onChildUpdate={checkAdminAccess} /> : <></>}</Tab.Pane>
								
									{/*  **** Inactive Accounts  *****/}
									<Tab.Pane eventKey="inactive">
										{inactiveAccountsActive === true ? <AdminInactiveAccounts currentUser={props.currentUser} onChildUpdate={checkAdminAccess} /> : <></>}
									</Tab.Pane>
									{/*  **** Supplier Settings *****/}
									<Tab.Pane eventKey="supplierSettings">
										{supplierSettingsActive === true ? <AdminSupplierSettings currentUser={props.currentUser} currentCompanyId={currentSupplier} onChildUpdate={checkAdminAccess} /> : <></>}
									</Tab.Pane>
									{/*  **** PeopleSoft Files  *****/}
									<Tab.Pane eventKey="peopleSoftFiles">
										{peopleSoftFilesActive === true ? <AdminPeopleSoft onChildUpdate={checkAdminAccess} /> : <></>}
									</Tab.Pane>
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                  

                    : (pending)
                        ? <div style={{ marginTop: "10px",margin: "auto", width: "100px" }}>
                            <Loading />
                        </div>
                        : <h3 style={{ marginTop: "10px" }}>You do not have access rights to this page.</h3>
            }
        </Container>
        );
    }
